<template>
  <div class="header">
    <nav class="nav">
      <ul>
        <!-- <li class="on"> -->
        <li :class="{'on':isCSSON}">
          <router-link to="/">
            首页
          </router-link>
        </li>
        <li>所有产品
          <div class="cart-box user-box">
            <div class="category" v-for="(item,index) in categoryList" :key="index">
              <span class="firstspan" @click="jumpCategory(item,-1)">{{item.classifyName}}</span>
              <ul>
                <li v-for="(itemC,indexC) in item.childs" :key="indexC">
                  <span class="secondspan" @click="jumpCategory(itemC,-1)">{{itemC.classifyName}}</span>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li v-for="(item,index) in navShowClassify.slice(0, 6)" :key="index" @click="jumpCategory(item,index)" :class="{on: activeIndex === index}">
          {{item.classifyName}}
        </li>
        <li>
           <a href="http://114.215.113.194:8093" target="_blank">物流名片</a>
        </li>
      </ul>
    </nav>
    <div class="search">
      <div class="searchSelect">
        <el-dropdown @command="searchCommand" trigger="click">
              <span class="el-dropdown-link">{{searchVal}}
                <i class="el-icon-arrow-down cur-poi el-icon--right"></i>
              </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="宝贝">宝贝</el-dropdown-item>
            <el-dropdown-item command="店铺">店铺</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="searchRight">
        <input type="text"
          v-model="keyword"
          @keyup.enter="searchPro"
          placeholder="请输入搜索商品"
        >
      </div>
      <span class="btn cur-poi" @click="searchPro">
        <i class="icon el-icon-search"></i>
      </span>
    </div>
  </div>
</template>

<script>
import {
  getCategory, getNavShowClassify
} from '@/api/nav.js'
import { mapMutations } from 'vuex'
export default {
  name: 'homHeader',
  data () {
    return {
      searchVal: '宝贝',
      keyword: '',
      categoryList: [],
      navShowClassify: [],
    }
  },
  props: {
      isCSSON: {
        type: Boolean,
        default: true
      },
      activeIndex: {
        type: Number,
        default: -1
      }
    },
  mounted () {
    this.getCategoryData()
    this.getNavShowClassify()
  },
  methods: {
    ...mapMutations({
      setSearchObj: 'SET_SEARCHOBJ'
    }),
    searchCommand (command) {
      this.searchVal = command
    },
    // 查找
    searchPro () {
      this.setSearchObj({
        keyword: this.keyword,
        searchVal: this.searchVal
      })
      if (this.$route.name !== 'search') {
        this.$router.push({
          path: '/activity/search'
        })
      }
    },
    async getCategoryData () {
      const response = await getCategory()
      const res = response.data
      if (res.code === '200') {
        this.categoryList = res.data
      }
    },
    async getNavShowClassify () {
      const response = await getNavShowClassify()
      const res = response.data
      if (res.code === '200') {
        this.navShowClassify = res.data
      }
    },
    // 跳转到类别主页
    jumpCategory (item, index) {
      this.$router.push({
        name: 'category',
        query: {
          classifyData: JSON.stringify(item),
          index: index
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
$lightBlack: #666666;
$navSearchHeight: 39px;
.header{
  height: 80px;
  width: 1250px;// xgl modify 1200修改为1250
  margin: 0 auto;
  .nav{
    float: left;
    padding-top: 30px;
    li{
      display: inline-block;
      font-size: 16px;
      line-height: 21px;
      padding-bottom: 24px;
      color: #333;
      cursor: pointer;
      border-bottom: 3px solid #fff;
      margin-left: 45px;// xgl modify 55修改为45
      &:first-child{
        margin-left: 0;
      }
      &.on,&:hover{
        color: #C5AA7B;
        border-color: #C5AA7B;
      }
    }
  }
  .search{
    width: 340px;// xgl modify 394修改为340
    height: 39px;
    border: 1px solid #D2D2D2;// xgl modify  2px修改为1px;#F3F4F5修改为#CCCCCC
    float: right;
    margin-top: 21px;
    display: flex;
    .searchSelect{
      width: 82px;
      height: 30px;
      margin-top: 2px;
      border-right: 1px solid #CCCCCC;
      text-align: center;
      line-height: 30px;
      .el-dropdown{
        color: #C5AA7B;
      }
    }
    .searchRight{
      flex: 1;
      input{
        padding-left: 15px;
        font-size: 14px;
        color: #333;
        line-height: 35px;
      }
    }
    .btn{
      font-size: 20px;
      line-height: 35px;
      padding-right: 15px;
    }
  }
  .nav li:nth-child(2){
    border: none;
    display: inline-block;
    position: relative;
    &:hover{
      background-color: #fff;
      .user-box{
        display: block;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
  .cart-box{
    cursor:default;
    position: absolute;
    top: 49px;
    background-color: #fff;
    z-index: 999;
    border-radius: 5px;
    box-shadow: 0px 0px 24px 3px rgba(0, 0, 0, 0.06);
    &.user-box{
      width: 1000px;
      top: 40px;
      right:-920px;
      display: none;
    }
    padding:10px;
    font-size:0px;
    max-height: 450px;
    overflow: hidden;
    overflow-y: auto;
    .category
    {
      display: inline-block;
      vertical-align: top;
      width:180px;
      color:#545454;
      padding:0;
      margin:0 0 30px 0;
      .firstspan{
        cursor: pointer;
        width:160px;
        font-size: 14px;
        display:inline-block;
        line-height: 25px;
        border-bottom: 1px dashed #545454;
        &:hover{
          color:#C5AA7B;
        }
      }
      ul li:nth-child(n+1){
        border: none;
        &:hover{
          color:#545454;
        }
      }
      ul {
        padding-top:10px;
        width:170px;
        li {
          float:left;
          cursor:default;
          padding:0;
          margin:0 10px 0 0;
          height: 20px;
          .secondspan{
            cursor: pointer;
            display: inline-block;
            font-size: 13px;
            line-height: 12px;
            &:hover{
              color:#545454;
              border-bottom: 1px solid #545454;
            }
          }
        }
      }
    }
  }
  .cart-box::-webkit-scrollbar {
    width: 10px;
    height: 5px;
  }
  .cart-box::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: #D6D6D6;
  }
</style>



// WEBPACK FOOTER //
// src/components/base/homHeader.vue